import React, { useState } from 'react';
import './TestimonialContact.css';

function TestimonialContact({ content }) {
  const [showForm, setShowForm] = useState(false);

  const handleShowForm = () => {
    setShowForm(true);
  };

  const handleHideForm = () => {
    setShowForm(false);
  };

  return (
    <div className="TestimonialContact-main">
      <div>
        <h1 className="TestimonialContact-heading">
          {content.availableHeading}
        </h1>
      </div>
      <div className="TestimonialContact">
        <div className="Contact1">
          <h2 style={{ cursor: 'pointer' }}>
            <a href="/contact-us" className="TestimonialContact-link">
              {content.availableText1}
            </a>
          </h2>
        </div>
        <div className="Contact2">
          <h2 
            style={{ cursor: 'pointer' }} 
            onClick={handleShowForm}
            role="button"
            tabIndex={0}
            onKeyDown={(e) => {
              if (e.key === 'Enter' || e.key === ' ') {
                e.preventDefault();
                handleShowForm();
              }
            }}
          >
            {content.availableText2}
          </h2>
        </div>
      </div>
      {showForm && (
        <form className="newsletter-form" onSubmit={async (e) => {
          e.preventDefault();
          const form = e.target;
          const email = form.email.value;
          const firstName = form.firstName.value;
          const lastName = form.lastName.value;
          const res = await fetch('/api/newsletter-signup', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ email, firstName, lastName })
          });
          if (res.ok) {
            alert('Thank you for signing up!');
            form.reset();
            handleHideForm();
          } else {
            alert('There was an error. Please try again.');
          }
        }}>
          <label>{content.newsletterLabelEmail || 'Email (required) *'}</label>
          <input type="email" name="email" required />
          <label>{content.newsletterLabelFirstName || 'First Name *'}</label>
          <input type="text" name="firstName" required />
          <label>{content.newsletterLabelLastName || 'Last Name'}</label>
          <input type="text" name="lastName" />
          <button type="submit">{content.newsletterButtonSubmit || 'SIGN UP'}</button>
          <button type="button" className="newsletter-close" onClick={handleHideForm}>
            {content.newsletterButtonClose || 'Close'}
          </button>
          <p className="newsletter-disclaimer">
            {content.newsletterDisclaimer || 'By submitting this form, you are consenting to receive marketing emails from YINN. You can revoke your consent at any time by contacting support@yinn.ca.'}
          </p>
        </form>
      )}
    </div>
  )
}

export default TestimonialContact